module.exports = __webpack_public_path__ + "static/media/perfiloff.21f70f65.svg";